import React from 'react'
import styled from 'styled-components'
import {BodyText} from './text.js'
import theme from './theme.js'
import Link from './link.js'
import SubMenu from './header-menu-main-desktop-sub-menu.js'

const UnstyledItem = ({
  className,
  item
}) => {
  const title = item.title

  const props = {
    className,
    ...item
  }

  const linkProps = {
    to: item.to,
    url: item.url
  }

  return (
    <div {...props}>
      <Link {...linkProps}>
        <Title>{title}</Title> 
      </Link>
      <SubMenu items={item.subItems}/>
    </div>
  )
}

const Item = styled(UnstyledItem)`
  display: inline-block;
  margin-left: 2em;
  --subMenuVis: 'none';

  :last {
    margin-right: 0;
  }

  &:hover {
    .sub-menu {
      display: block;
    }
  }
`

const Title = styled(BodyText)`
  font-size: ${theme.font.size.p2};
  
  &:hover {
    font-family: ${theme.font.family.link};
  }
`



export default Item